import '@f-fertighaus/layout/PageHeader/SSR/PageHeaderSSR'
import '@f/components/PageSharing'
import '@js/common/site-wide'
import '@f/elements/AnchorsNavigation'
import '@f/widgets/CardCarousel/CardCarouselHTML'
import '@f/wagtail-blocks/HouseMosaic'
import '@f/wagtail-blocks/Carousel'
import '@f/wagtail-blocks/QuizWidget'
import '@f/wagtail-blocks/ProcessSection'
import '@f/wagtail-blocks/Vendors'
import '@f-fertighaus/components/YoutubeVideo/YoutubeVideoHTML'
import '@f-fertighaus/widgets/FloatingBanner'

import React from 'react'
import { createRoot } from 'react-dom/client'

import { patch, post } from '@js/common/api'
import { getUrl } from '@js/common/getUrlByDomain'

import Modal from '@f/components/Modal'

import BudgetCalculatorModal from '@f-fertighaus/applications/BudgetCalculatorModal'
import FinanceEntry, {
  FinanceEntryPanel
} from '@f-fertighaus/applications/FinanceEntry'
import { handleLineClampAdjustment } from '@f-fertighaus/utils/handleLineClampAdjustment'

/* Hash modal opening */
if (window.location.hash.includes('budget-calc')) {
  setTimeout(() => {
    const modal = new Modal()

    modal.openModal({
      component: (
        <BudgetCalculatorModal {...window.SherlockContainer.BudgetCalculator} />
      )
    })
  }, 1000)
} else if (window.location.hash.includes('budgethilfe')) {
  setTimeout(() => {
    const modal = new Modal()

    const openFlow = flowType => {
      let nextModal = new Modal()

      if (flowType === 'budget_calculator') {
        nextModal.openModal({
          component: (
            <BudgetCalculatorModal
              {...window.SherlockContainer.BudgetCalculator}
            />
          )
        })
      }
    }

    modal.openModal({
      component: <FinanceEntryPanel openFlow={openFlow} />,
      options: {
        className: 'ModalFinance'
      }
    })
  }, 1000)
} else if (window.location.hash.includes('finance')) {
  window.location.href = getUrl('financeAssistance')()
}

/* Parallax background */
void (function () {
  var parallaxElements = [...document.querySelectorAll('.hlp-hero-image')]

  const updateElementPosition = () => {
    parallaxElements.forEach(element => {
      var speed = element.dataset.parallax || 0.2
      var offset = -(window.pageYOffset - element.offsetTop) * speed

      element.style.transform = 'translate3d(0, ' + offset + 'px, 0)'
      element.style.OTransform = 'translate3d(0, ' + offset + 'px, 0)'
      element.style.msTransform = 'translate3d(0, ' + offset + 'px, 0)'
      element.style.MozTransform = 'translate3d(0, ' + offset + 'px, 0)'
      element.style.WebkitTransform = 'translate3d(0, ' + offset + 'px, 0)'
    })
  }

  if (parallaxElements.length) {
    if (window.innerWidth >= 750) {
      updateElementPosition()
    }

    window.onscroll = function () {
      if (window.innerWidth >= 750) {
        updateElementPosition()
      }
    }
  }
})()

/* Dynamic scrollable tables */
void (function () {
  let tables = [...document.querySelectorAll('.table table')]

  tables.map(table => {
    let checkTable = () => {
      if (table.scrollWidth > table.offsetWidth) {
        table.parentNode.parentNode.classList.add('has-scroll')
      } else {
        table.parentNode.parentNode.classList.remove('has-scroll')
      }
    }

    checkTable()

    window.addEventListener('resize', () => {
      checkTable()
    })
  })
})()

/* Smooth scrolling */
void (function () {
  const scrollTriggers = document.querySelectorAll('.js-smooth-scroll')

  for (const scrollTrigger of scrollTriggers) {
    scrollTrigger.addEventListener('click', function (event) {
      event.preventDefault()

      window.scrollTo({
        top: document.querySelector(scrollTrigger.getAttribute('href'))
          .offsetTop,
        behavior: 'smooth'
      })
    })
  }
})()

/* Check if any link contain the budget-calc trigger */
void (function () {
  let container = document.querySelector('main')
  container.addEventListener('click', function (event) {
    const target = event.target

    if (target.href && /#budgethilfe/.test(target.href)) {
      event.preventDefault()

      const modal = new Modal()

      const openFlow = flowType => {
        let nextModal = new Modal()

        if (flowType === 'budget_calculator') {
          nextModal.openModal({
            component: (
              <BudgetCalculatorModal
                {...window.SherlockContainer.BudgetCalculator}
              />
            )
          })
        }
      }

      modal.openModal({
        component: <FinanceEntryPanel openFlow={openFlow} />,
        options: {
          className: 'ModalFinance'
        }
      })
    }

    if (target.href && /#budget-calc/.test(target.href)) {
      event.preventDefault()

      const modal = new Modal()

      modal.openModal({
        component: (
          <BudgetCalculatorModal
            {...window.SherlockContainer.BudgetCalculator}
          />
        )
      })
    }

    if (target.href && /#finance/.test(target.href)) {
      event.preventDefault()

      window.location.href = getUrl('financeAssistance')()
    }
  })
})()

/* Finance Wizard */
void (function () {
  let financeEntryMount = document.querySelector('.js-finance-entry')
  if (financeEntryMount) {
    const root = createRoot(financeEntryMount)
    root.render(<FinanceEntry />)
  }
})()

/* Star Rating */
void (function () {
  // Star rating unfilled event listeners
  let starRatingUnfilled = document.querySelectorAll('.js-star-rating-unfilled')
  for (const star of starRatingUnfilled) {
    star.addEventListener('click', function () {
      if (
        document.querySelector('.js-ArticleRatingTitle').innerText ==
        'Vielen Dank!'
      ) {
        return
      }
      let starRatingUnfilled = document.querySelectorAll(
        '.js-star-rating-unfilled'
      )
      let starRatingFilled = document.querySelectorAll('.js-star-rating-filled')
      let rating = parseInt(star.dataset['rating'])
      for (let i = 0; i < rating; i++) {
        starRatingFilled[i].style.display = 'block'
        starRatingUnfilled[i].style.display = 'none'
      }
      post(`/rating/${star.dataset['page']}/`, {
        rating: star.dataset['rating']
      }).then(data => {
        let rating = data['rating']['rating__avg'] + ''
        document.querySelector('.js-rating-text').style.display = 'block'
        document.querySelector('.js-placeholder-text').style.display = 'none'
        document.querySelector('#ratingValue').innerText = rating
          .replace('.', ',')
          .substring(0, 4)
        document.querySelector('#totalRatings').innerText = data['total']
        window.localStorage.setItem('ratingUUID', data['uuid'])
        document.querySelector('.js-ArticleRatingTitle').innerText =
          'Vielen Dank!'
        document.querySelector('.js-ratingstep2').style.display = 'block'
      })
    })
  }

  // Send feedback button
  const sendFeedback = document.querySelector('.js-send-feedback')
  if (sendFeedback) {
    sendFeedback.addEventListener('click', function () {
      let page = document.querySelector('.js-ratingstep2').dataset['page']
      document.querySelector('.js-ratingstep2').style.display = 'none'
      document.querySelector('.js-ratingstep3').style.display = 'block'
      patch(`/rating/${page}/`, {
        comment: document.querySelector('[name=star-rating-message]').value,
        uuid: window.localStorage.getItem('ratingUUID')
      })
    })
  }
})()

/* Fullscreen Gallery */
void (async function () {
  let cdnImages = document.querySelectorAll('[data-zoom-src]')
  if (cdnImages.length) {
    const { default: FullscreenGallery } = await import(
      '@js/ancient-code/FullscreenGallery'
    )
    for (const image of cdnImages) {
      image.addEventListener('click', () => {
        const modal = new Modal()
        modal.openModal({
          component: <FullscreenGallery slides={[image.dataset.zoomSrc]} />
        })
      })
    }
  }
})()

/* CardLinks line clamp */
void (function adjustDescriptionClampMosaicGallery() {
  const imageDescriptions = document.querySelectorAll('.CardLinkLarge-content')

  if (imageDescriptions.length === 0) {
    return
  }
  imageDescriptions.forEach(imageDescription => {
    handleLineClampAdjustment({
      containerElement: imageDescription,
      spacingAroundContainer: 32,
      spacingBelowTitle: 8,
      customLineToRemove: 1
    })
  })
})()

void (async function dynamicallyImportWagtailBlocks() {
  const houseListMountPoint = document.querySelector('#HouseSearchList')
  const exclusiveLeadsHuseListMountPoint = document.querySelector(
    '#EXHouseSearchList'
  )
  const vendorListMountPoint = document.querySelector('#VendorSearchList')
  const vendorCarouselMountPoint = document.querySelector(
    '.js-vendor-carousel-wrapper'
  )
  const vendorPremiumPlacementMountPoint = document.querySelector(
    '.js-vendor-premium-placement-wrapper'
  )
  const testimonialsCarouselMountPoint = document.querySelector(
    '.js-testimonials-carousel'
  )
  const calculatorMountPoint = document.querySelector('.js-calculator-block')
  const interactiveMapMountPoint = document.querySelector(
    '.js-interactive-state-map-select'
  )
  const stairsCalculatorMountPoint = document.querySelector(
    '#stairs-calculator'
  )
  const gritCalculatorMountPoint = document.querySelector('#grit-calculator')
  const gardenWaterCalculatorMountPoint = document.querySelector(
    '#garden-water-calculator'
  )
  const quizWidgetContentBlock = document.querySelector(
    '#js-quiz-widget-content-block'
  )
  const imAdsMountPoint = document.querySelector('#im-ads')
  const contactUsMountPoint = document.querySelector(
    '#js-questions-form-mount-point'
  )

  if (houseListMountPoint) {
    await import('@f/wagtail-blocks/HouseSearchList')
  }
  if (exclusiveLeadsHuseListMountPoint) {
    await import('@f/wagtail-blocks/EXHouseSearchList')
  }
  if (vendorListMountPoint) {
    await import('@f/wagtail-blocks/VendorSearchList')
  }
  if (vendorCarouselMountPoint) {
    await import('@f/wagtail-blocks/VendorCarousel')
  }
  if (testimonialsCarouselMountPoint) {
    await import('@f/wagtail-blocks/Testimonials')
  }
  if (calculatorMountPoint) {
    await import('@f/wagtail-blocks/Calculator')
  }
  if (interactiveMapMountPoint) {
    await import('@f/wagtail-blocks/InteractiveStateMap')
  }
  if (stairsCalculatorMountPoint) {
    await import('@f/wagtail-blocks/StairsCalculatorWidget')
  }
  if (gritCalculatorMountPoint) {
    await import('@f/wagtail-blocks/GritCalculatorWidget')
  }
  if (gardenWaterCalculatorMountPoint) {
    await import('@f/wagtail-blocks/GardenWaterCalculatorWidget')
  }
  if (quizWidgetContentBlock) {
    await import('@f/wagtail-blocks/QuizWidgetContent')
  }
  if (imAdsMountPoint) {
    await import('@f-fertighaus/components/BannerAds')
  }
  if (vendorPremiumPlacementMountPoint) {
    await import(
      '@f/wagtail-blocks/PremiumPlacementWidget/PremiumPlacementWidget'
    )
  }
  if (contactUsMountPoint) {
    await import('@f/wagtail-blocks/ContactUs/ContactUs')
  }
})()
